export default __webpack_public_path__ + "static/media/rejected-big.b094ccd1.svg";